import { render, staticRenderFns } from "./RegistrationFormEditor.vue?vue&type=template&id=48699b2b&scoped=true&"
import script from "./RegistrationFormEditor.vue?vue&type=script&lang=js&"
export * from "./RegistrationFormEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48699b2b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VDivider,VSwitch})
